import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';
import { AppAuthGuard } from './app.authguard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },
  {
    path: 'match-game',
    redirectTo: 'match-game',
    pathMatch: 'full'
  },
  {
    path: 'live-session/organization/:orgId/group/:groupId/practiceset/:practicesetId/table/:tableId',
    loadChildren: () => import('./modules/live-session-play/live-session-play.module').then(m => m.LiveSessionPlayModule),
  },
  {
    path: 'live-session/organization/:orgId/group/:groupId/practiceset/:practicesetId/table/:tableId/version/:versionId',
    loadChildren: () => import('./modules/live-session-play/live-session-play.module').then(m => m.LiveSessionPlayModule),
  },
  {
    path: 'live-session/pins/:liveSessionId/:userId',
    loadChildren: () => import('./modules/live-session-play/live-session-play.module').then(m => m.LiveSessionPlayModule),
  },
  {
    path: 'multiGamePlayQuiz',
    loadChildren: () => import('./modules/multi-game-play-quiz/multi-game-play-quiz.module').then(m => m.MultiGamePlayQuizModule),
  },
  {
    path: 'multiGamePlay',
    loadChildren: () => import('./modules/main/multi-game-play/multi-game-play.module').then(m => m.MultiGamePlayModule),
  },
  {
    path: 'share/organization/:orgId/group/:groupId/practiceset/:practicesetId/table/:tableId/leaderboard/:leaderboardId',
    loadChildren: () => import('./modules/share-play/share-play.module').then(m => m.SharePlayModule),
  },
  {
    path: 'main',
    loadChildren: () => import('./modules/main/main.module').then(m => m.MainModule),
    canActivate: [AppAuthGuard]
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})
export class AppRoutingModule { }
